<template>
    <div class="content-header clearfix">
        <i class="icon-nav-bg"></i>
        <ul class="topnav">
            <li v-for="(tab, index) in tabs"
                :class="{ active: nav === tab }"
                v-on:click="navLink(tab)">

                <a href="javascript:void(0);">{{ tab }}</a>
            </li>
        </ul>

        <!-- <div class="nav-prom" v-if="isOfficalChannel() || isAsusChannel()">
            Buy Lifetime License, get 1 year FREE Office Premium!
            <button class="nav-prom-btn" @click="purchaseNow">Purchase Now</button>
        </div> -->

        <!-- <div class="krazybee-nav" v-if="isIndia">
            <span>Indian startup get your ₹900.000 reward</span>
            <button class="krazybee-nav-btn" @click="goKrazybee">Go</button>
        </div> -->

        <div class="pull-right">
            <slot></slot>
            <span class="btn-refresh" v-on:click="refreshPage()">
                <i id="icon_refresh_common" class="icon-refresh-common"></i>
                Refresh
            </span>
        </div>

        <i class="navbar-promotion-img" @click.stop="openPromotion" v-if="toPromotion" v-show="isShowPromotion"></i>
    </div>
</template>

<script>
import Util from '../../assets/js/util.js';
import axios from 'axios';

const _start = new Date();
let rotateLock = false;

export default {
    name: 'navbar',

    data() {
        return {
            toPromotion: false,
            isShowPromotion: true,
            isIndia: false,
        }
    },

    props: {
        isLogin: {
            type: Boolean,
            default: false
        },
        nav: {
            type: String,
            default: ''
        },
        tabs: {
            type: Array,
            default: []
        }
    },

    mounted() {
        ga('send', 'timing', '/navbar', 'load', new Date() - _start);

        let self = this;
        let elem = this.$el;

        let vip_user = Util.Cookie.find('wps_paid') == 1;
        self.showPromotion(!vip_user);

        window.addEventListener('resize', function () {
            let width = elem.offsetWidth;
            self.showPromotion(!vip_user && width >= 1000);
        }, false);

        VEvts.$on('VIP_STATUS_CHANGE', () => {
            vip_user = Util.Cookie.find('wps_vip') == 1 || Util.Cookie.find('wps_paid') == 1;
            self.showPromotion(!vip_user);
        });

        VEvts.$on('WPSPAID_STATUS_CHANGE', function() {
            vip_user = Util.Cookie.find('wps_paid') == 1;
            self.showPromotion(!vip_user);
        });

        this.checkIndia();
    },

    methods: {
        navLink(tab) {

            if(tab && tab =='WPS Premium'){
                Util.gaReport('send', 'event','/vipIntroduce/tabs','click');
            }
            if (!~this.tabs.indexOf(tab)) { return; }

            this.$emit('navbar_link', tab);
        },

        refreshPage() {
            if (rotateLock) { return; }
            rotateLock = true;

            Util.elemRotate('icon_refresh_common', 2, function (elem) {
                rotateLock = false;
            });

            this.$emit('navbar_refresh');
        },

        showPromotion(show) {
            this.isShowPromotion = show;
        },

        openPromotion() {
            Util.jsAsynCall('openUrl', { 'url': 'https://www.wps.com/office-personal-home-smb?event=homepage_navbar' });
            Util.gaReport("send", "event", "/navbar/promotion", "click");
        },

        purchaseNow() {
            if (this.isOfficalChannel()) {
                Util.jsAsynCall('openUrl', { 'url': 'https://secure.wps.com/order/checkout.php?PRODS=4675527&QTY=1&CART=1&CARD=2&SHORT_FORM=1&DESIGN_TYPE=1&SRC=docer_license' });
            } else if (this.isAsusChannel()) {
                Util.jsAsynCall('openUrl', { 'url': 'https://secure.avangate.com/order/checkout.php?PRODS=4675527&QTY=1&INFO4675527=ASUS%20Upgrade%20-%20SAVE%20%2430%20USD&CART=1&CARD=2&DESIGN_TYPE=1&SHORT_FORM=1&ORDERSTYLE=nLWo4pXfiHQ=&SRC=docer_asus_license&BACK_REF=https://www.wps.com/instructions&PRICES4675527[USD]=49.95&PHASH=58f37c58d2988e79558c99540f5b9aa3' });
            }
            Util.gaReport('send', 'event', 'banner/purchaseNow', 'click');
        },

        isOfficalChannel() {
            return ['00100.00000101', '00100.00000103', '00100.00000121', '00100.00000122', '00100.00000123', '00100.00000105', '00100.00000106'].indexOf(window.AppInfo.disnum) >= 0;
        },

        isAsusChannel() {
            return ['00300.00000101', '00300.00000102', '00300.00000103', '00300.00000350', '00300.00000302'].indexOf(window.AppInfo.disnum) >= 0;
        },

        checkIndia() {
            axios.get('https://pc-serv.wps.com/api/my-country').then(res => {
                if (res.data === 'IN') {
                    this.isIndia = true;
                    document.body.style.minWidth = '1520px';
                }
            });
        },

        goKrazybee() {
            Util.gaReport('send', 'event', 'banner/goKrazybee', 'click');
            Util.jsAsynCall('openUrl', { 'url': 'https://www.wps.com/krazybee/op-krazybee-inapp.html' });
        },
    }
}
</script>

<style>
.content-header {
    position: relative;
    min-width: 740px;
    height: 60px;
    background: -prefix-linear-zgradient(top, #6aa0e3, #689bda);
    background: -webkit-linear-gradient(#6aa0e3, #689bda);
}


/* nav */

.topnav {
    display: inline-block;
    margin: 12px 0 0 46px;
}

.topnav li {
    display: inline-block;
}

.topnav .active {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background: #f7f6f6;
}

.topnav a {
    display: block;
    height: 48px;
    padding: 0 20px;
    font-size: 18px;
    line-height: 49px;
    color: #fff;
    text-align: center;
}

.topnav .active a {
    color: #3d7bc7;
}


/* right-side */

.btn-refresh {
    display: inline-block;
    vertical-align: middle;
    width: 75px;
    height: 60px;
    color: #fff;
    text-align: center;
    cursor: pointer;
}

.btn-refresh .icon-refresh-common {
    display: block;
    margin: 13px auto 0;
}

/* promotion */
.navbar-promotion-img {
    position: relative;
    display: inline-block;
    float: right;
    width: 400px;
    height: 50px;
    margin: 5px 40px 5px 0;
    cursor: pointer;
    background: url('http://file1.pc.wpscdn.com/ksodl/wpscfg/docer/docer-promotion-400x50.png');
}

.nav-prom {
    display: inline-block;
    font-family: Arial, Helvetica, sans-serif;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    word-spacing: 1px;
    padding: 0 15px;
}

.nav-prom-highlight {
    font-style: italic;
    color: #ffea5d;
    font-size: 18px;
    font-weight: 700;
}

.nav-prom-btn {
    background-color: #3cb9ff;
    color: #fff;
    border-radius: 50px;
    outline: none;
    border: 0;
    padding: 2px 10px;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    margin-left: 8px;
    vertical-align: bottom;
    font-family: 'Segoe UI';
}

.krazybee-nav {
    display: inline-block;
    font-family: Arial, Helvetica, sans-serif;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    word-spacing: 1px;
    padding: 0 15px;
}

.krazybee-nav-btn {
    color: #fff;
    background-color: rgba(255, 255, 255, .2);
    height: 25px;
    width: 75px;
    border: 0;
    outline: none;
    border-radius: 25px;
    margin-left: 20px;
    font-weight: 600;
    cursor: pointer;
}

.krazybee-nav-btn:hover {
    background-color: rgba(255, 255, 255, .3);
}

.content-header .icon-nav-bg {
    background-image: url('../../assets/images/banner_wave.png');
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    right: 0;
    top: 0;
    left: auto;
    background-position: 0 0;
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?56df6991